/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomSelect from './paquetes-checkout-nacionalidad-select';

const PanelPasajero = (props) => {
  const { t } = useTranslation('translations');
  const armarDiasMes = () => {
    const listaDias = [];
    let numeroDia = 1;
    for (let indice = 1; indice <= 31; indice++) {
      numeroDia = indice < 10 ? `0${indice}` : indice;
      listaDias.push(<option key={indice} value={numeroDia}>{numeroDia}</option>);
    }
    return listaDias;
  };

  const armarAnios = () => {
    const listaAnios = [];
    for (let indice = 1930; indice <= 2017; indice++) {
      listaAnios.push(<option key={indice} value={indice}>{indice}</option>);
    }
    return listaAnios;
  };

  const armarMeses = () => {
    const listaMeses = [];
    let numeroMes;
    for (let indice = 1; indice <= 12; indice++) {
      numeroMes = indice < 10 ? `0${indice}` : indice;
      listaMeses.push(<option key={indice} value={numeroMes}>{numeroMes}</option>);
    }
    return listaMeses;
  };
  const inputClasses = 'shadow appearance-none border rounded w-full py-2 px-3 text-gray-400 text-xs leading-tight focus:outline-none focus:shadow-outline';
  const labelClasses = 'block text-gray-700 text-sm mb-2';
  const nacionalidad
    = (
      <div className='form-group'>
        <label className={labelClasses} htmlFor='nacionalidad'>
          {t('checkout.nationality')}
        </label>
        <CustomSelect
          change={props.actualizarPasajeros}
          dataIndice={props.indice}
          dataName='nationality'
          id='nacionalidad'
          name='nacionalidad'
          className={inputClasses}
          data={props.nacionalidades}
          defaultValue={props.pasajeros[props.indice] ? props.pasajeros[props.indice].nationality : ''}
          required
        />
      </div>
    );

  const residencia
  = (
    <div className='form-group'>
      <label className={labelClasses} htmlFor='residencia'>
        {t('checkout.residence')}
      </label>
      <CustomSelect
        change={props.actualizarPasajeros}
        dataIndice={props.indice}
        dataName='residence'
        id='residencia'
        name='residencia'
        data={props.nacionalidades}
        defaultValue={props.pasajeros[props.indice] ? props.pasajeros[props.indice].residence : ''}
        className={inputClasses}
        required
      />
    </div>
  );

  const tipoDocumento
  = (
    <div className='form-group'>
      <label className={labelClasses} htmlFor='tipo-documento'>
        {t('checkout.idType')}
        {' '}
        *
      </label>
      <select
        onChange={props.actualizarPasajeros}
        data-indice={props.indice}
        data-name='documentType'
        id='tipo-documento'
        name='tipo-documento'
        className={inputClasses}
        required
      >
        <option value=''>{t('checkout.select')}</option>
        <option value='DNI'>{t('checkout.dni')}</option>
        <option value='DNI'>{t('checkout.passport')}</option>
      </select>
    </div>
  );

  const tipoDocumentoEurovips
  = (
    <div className='form-group'>
      <label className={labelClasses} htmlFor='tipo-documento'>
        {t('checkout.idType')}
      </label>
      <select
        onChange={props.actualizarPasajeros}
        data-indice={props.indice}
        data-name='documentType'
        id='tipo-documento'
        name='tipo-documento'
        className={inputClasses}
        required
      >
        <option value='PAS'>{t('checkout.passport')}</option>
      </select>
    </div>
  );

  const tipoDocumentoAfipEurovips
  = (
    <div className='form-group'>
      <label className={labelClasses} htmlFor='tipo-documento'>
        {t('checkout.idType')}
        {' '}
        *
      </label>
      <select
        onChange={props.actualizarPasajeros}
        data-indice={props.indice}
        data-name='documentTypeAfip'
        id='tipo-documento-afip'
        name='tipo-documento-afip'
        className={inputClasses}
        required
      >
        <option value='DNI'>{t('checkout.dni')}</option>
      </select>
    </div>
  );

  const numeroDocumento
  = (
    <div className='form-group'>
      <label
        className={labelClasses}
        htmlFor='numero-documento'
      >
        {t('checkout.idNumber')}
      </label>
      <input
        onChange={props.actualizarPasajeros}
        data-indice={props.indice}
        data-name='documentNumber'
        id='numero-documento'
        name='numero-documento'
        type='text'
        placeholder={t('checkout.idNumberTip')}
        className={inputClasses}
        required
      />
    </div>
  );

  const numeroDocumentoEurovips
  = (
    <div className='form-group'>
      <label
        className={labelClasses}
        htmlFor='numero-documento'
      >
        {t('checkout.passportNumber')}
      </label>
      <input
        onChange={props.actualizarPasajeros}
        data-indice={props.indice}
        data-name='documentNumber'
        id='numero-documento'
        name='numero-documento'
        type='text'
        placeholder={t('checkout.idNumberTip')}
        className={inputClasses}
        required
      />
    </div>
  );

  const numeroDocumentoAfipEurovips = (
    <div className='form-group'>
      <label
        className={labelClasses}
        htmlFor='numero-documento'
      >
        {t('checkout.idNumber')}
      </label>
      <input
        onChange={props.actualizarPasajeros}
        data-indice={props.indice}
        data-name='documentNumberAfip'
        id='numero-documento-afip'
        name='numero-documento-afip'
        type='text'
        placeholder={t('checkout.idNumberTip')}
        className={inputClasses}
        required
      />
    </div>
  );

  const seccionDocumento
    = (
      <>
        <div className='col-span-1 md:col-span-1'>
          {tipoDocumento}
        </div>
        <div className='col-span-1 md:col-span-1'>
          {numeroDocumento}
          <div className='text-gray-400 text-xs pt-2'>
            *
            {' '}
            {t('checkout.tipDocument')}
          </div>
        </div>

        <div className='col-span-1 md:col-span-1'>
          {nacionalidad}
        </div>
        <div className='col-span-1 md:col-span-1'>
          {residencia}
        </div>
      </>
    );

  const seccionDocumentoEurovips
    = (
      <div>
        <div className='col-md-6 '>
          <div className='row'>
            <div className='clearfix'>
              <div className='col-md-4  col-sm-5 col-xs-5'>
                {tipoDocumentoEurovips}
              </div>
              <div className='col-md-8 col-sm-7 col-xs-7'>
                {numeroDocumentoEurovips}
                <div className='clearfix' />
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-6 '>
          <div className='row'>
            <div className='clearfix'>
              <div className='col-md-4  col-sm-5 col-xs-5'>
                {tipoDocumentoAfipEurovips}
              </div>
              <div className='col-md-8 col-sm-7 col-xs-7'>
                {numeroDocumentoAfipEurovips}
                <div className='clearfix' />
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-3'>
          {nacionalidad}
        </div>
        <div className='col-md-3'>
          {residencia}
        </div>
      </div>
    );

  const vencimientoDocuPythagoras
    = (
      <div className='form-group'>
        <label className={labelClasses} htmlFor='vencimiento'>
          {t('checkout.expirationDate')}
        </label>
        <div id='vencimiento' className='grid grid-cols-3 gap-1 '>
          <div className='col-span-1 '>
            <div className='form-group'>
              <div className='row'>
                <select
                  onChange={props.actualizarVencimientoPasaporte}
                  data-indice={props.indice}
                  data-name='passportExpirationDay'
                  id='vencimiento-dia'
                  name='passportExpirationDay'
                  className={inputClasses}
                  required
                >
                  <option value=''>{t('checkout.day')}</option>
                  {armarDiasMes()}
                </select>
              </div>
            </div>
          </div>
          <div className='col-span-1 '>
            <div className='form-group'>
              <div className='row'>
                <select
                  onChange={props.actualizarVencimientoPasaporte}
                  data-indice={props.indice}
                  data-name='passportExpirationMonth'
                  id='vencimiento-mes'
                  name='passportExpirationMonth'
                  className={inputClasses}
                  required
                >
                  <option value=''>{t('checkout.month')}</option>
                  {armarMeses()}
                </select>
              </div>
            </div>
          </div>
          <div className='col-span-1 '>
            <div className='form-group'>
              <div className='row'>
                <select
                  onChange={props.actualizarVencimientoPasaporte}
                  data-indice={props.indice}
                  data-name='passportExpirationYear'
                  id='vencimiento-ano'
                  name='passportExpirationYear'
                  className={inputClasses}
                  required
                >
                  <option value=''>{t('checkout.year')}</option>
                  {armarAnios()}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

  const seccionDocumentoPythagoras
    = (
      <>
        <div className='col-span-1 md:col-span-1'>

          {tipoDocumentoEurovips}
        </div>
        <div className='col-span-1 md:col-span-1'>
          {numeroDocumentoEurovips}

        </div>
        <div className='col-span-1 md:col-span-1'>
          {vencimientoDocuPythagoras}
        </div>

        <div className='col-span-1 md:col-span-1'>

          {tipoDocumentoAfipEurovips}
        </div>
        <div className='col-span-1 md:col-span-1'>
          {numeroDocumentoAfipEurovips}

        </div>

        <div className='col-span-1 md:col-span-1'>
          {nacionalidad}
        </div>
        <div className='col-span-1 md:col-span-1'>
          {residencia}
        </div>
      </>
    );

  return (
    <div>
      <div className='container bg-white my-4 p-6'>
        <div className='panel-body'>

          <div className='text-2xl  font-color-mbr-color-primario mb-2'>
            {props.title}
            {' '}
            <i className='far fa-user font-color-mbr-color-primario' aria-hidden='true' />
          </div>
          <div className='grid-cols-3 gap-4 text-sm sm:grid grid-cols-1 '>
            <div className='col-span-1 '>
              <div className='form-group'>
                <label className={labelClasses} htmlFor='nombre'>
                  {t('checkout.name')}
                </label>
                <input
                  onChange={props.actualizarPasajeros}
                  data-indice={props.indice}
                  data-name='firstName'
                  id='nombre'
                  name='nombre'
                  type='text'
                  placeholder={t('checkout.nameTip')}
                  className={inputClasses}
                  required
                />
              </div>
            </div>
            <div className='col-span-1'>
              <div className='form-group'>
                <label className={labelClasses} htmlFor='apellido'>
                  {t('checkout.lastName')}
                </label>
                <input
                  onChange={props.actualizarPasajeros}
                  data-indice={props.indice}
                  data-name='lastName'
                  id='apellido'
                  name='apellido'
                  type='text'
                  placeholder={t('checkout.nameTip')}
                  className={inputClasses}
                  required
                />
              </div>
            </div>
            <div className='col-span-1 '>
              <div className='form-group'>
                <label className={labelClasses} htmlFor='sexo'>
                  {t('checkout.sex')}
                </label>
                <select
                  onChange={props.actualizarPasajeros}
                  data-indice={props.indice}
                  data-name='gender'
                  id='sexo'
                  name='sexo'
                  className={inputClasses}
                  required
                >
                  <option value=''>{t('checkout.select')}</option>
                  <option value='M'>{t('checkout.male')}</option>
                  <option value='F'>{t('checkout.female')}</option>
                </select>
              </div>
            </div>
            <div className='col-span-1 md:col-span-1'>
              <label className={labelClasses} htmlFor='nacimiento'>
                {t('checkout.birthday')}
              </label>
              <div className='grid grid-cols-3 gap-1 '>

                <div className='col-span-1 md:col-span-1'>
                  <div className='form-group'>
                    <div className='col-span-1 md:col-span-1'>
                      <select
                        onChange={props.actualizarFechaNacimientoPasajeros}
                        data-indice={props.indice}
                        data-name='birthDay'
                        id='nacimiento-dia'
                        name='birthDay'
                        className={inputClasses}
                        required
                      >
                        <option value=''>{t('checkout.day')}</option>
                        {armarDiasMes()}
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-span-1 md:col-span-1'>
                  <div className='form-group'>
                    <div className='row'>
                      <select
                        onChange={props.actualizarFechaNacimientoPasajeros}
                        data-indice={props.indice}
                        data-name='birthMonth'
                        id='nacimiento-mes'
                        name='tipo-documento'
                        className={inputClasses}
                        required
                      >
                        <option value=''>{t('checkout.month')}</option>
                        {armarMeses()}
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-span-1 md:col-span-1'>
                  <div className='form-group'>
                    <div className='row'>
                      <select
                        onChange={props.actualizarFechaNacimientoPasajeros}
                        data-indice={props.indice}
                        data-name='birthYear'
                        id='nacimiento-ano'
                        name='birthYear'
                        className={inputClasses}
                        required
                      >
                        <option value=''>{t('checkout.year')}</option>
                        {armarAnios()}
                      </select>
                    </div>
                  </div>
                </div>

              </div>
              <div className='clearfix' />
            </div>
            {props.proveedorId === 4 ? seccionDocumentoEurovips : props.proveedorId >= 6 && props.proveedorId <= 9 ? seccionDocumentoPythagoras : seccionDocumento }
          </div>

        </div>
      </div>
    </div>
  );
};

export default PanelPasajero;
